import React, { useState, useEffect } from 'react';
import { Button, TextField, Backdrop, CircularProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useSnackbar } from 'notistack';

import Api from '../../../Api';
import Modal from '../../../components/Modal/Modal';

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 200px) !important'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: '#fff'
  }
}));

// mode: 'create' | 'rename'
const NewFolderModal = ({ handleClose, visibility, mode, parentId, folder }) => {
  const { enqueueSnackbar } = useSnackbar();
  const styles = useStyles();

  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === 'rename' && folder) {
      setName(folder.name || '');
    } else {
      setName('');
    }
  }, [mode, folder, visibility]);

  const handleCloseDismiss = () => {
    handleClose();
  };

  const handleSubmit = event => {
    event.preventDefault();
    setLoading(true);

    const request =
      mode === 'rename'
        ? Api.put('/drive_folders/' + folder.id, { name })
        : Api.post('/drive_folders', { name, parent_id: parentId || null });

    request
      .then(function() {
        setLoading(false);
        setName('');
        enqueueSnackbar(mode === 'rename' ? 'Carpeta renombrada exitosamente!' : 'Carpeta creada exitosamente!', {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'success'
        });
        handleClose(true);
      })
      .catch(function(error) {
        setLoading(false);
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          message = 'Ocurrio un error, intenta nuevamente.';
        }
        enqueueSnackbar(message, {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'error'
        });
      });
  };

  return (
    <div>
      <Modal handleClose={handleCloseDismiss} visibility={visibility} title={mode === 'rename' ? 'Renombrar Carpeta' : 'Nueva Carpeta'} maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            <TextField
              autoFocus
              fullWidth
              label="Nombre de la carpeta"
              name="name"
              type="text"
              onChange={e => setName(e.target.value)}
              value={name || ''}
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button disabled={!name || !name.trim()} type="submit" color="primary">
              {mode === 'rename' ? 'Guardar' : 'Crear'}
            </Button>
          </DialogActions>
        </form>
      </Modal>
      <Backdrop className={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default NewFolderModal;
